module.exports = __webpack_public_path__ + "img/back_width.c3ca802e.png";